import { getMessages, LanguageIsoCode } from 'locales';
import { ProductMetadata } from 'models/batch/import-metadata';

import { FieldInput } from '../fieldMetadata/fieldConfig';
import { ImportFormRequest } from '../import.models';
import { buildImportRequest, ImportedProductRow } from './fieldProcessingUtils';
import { createProductFieldMetadataMap } from './productMappingUtils';

export interface ParseError {
  type: string;
  code?: string;
  message: string;
  row?: number;
  index?: number;
}
export type DataMap = Record<string, FieldInput>;
export interface FileParseResult {
  locale: LanguageIsoCode;
  rows: ImportedProductRow[];
  errors: ParseError[];
}

export function buildImportRequests(
  fileParsedResult: FileParseResult,
  productsMetadata: ProductMetadata[],
): ImportFormRequest[] {
  const translationMap = getMessages(fileParsedResult.locale);
  const productFieldMetadataMap = createProductFieldMetadataMap(productsMetadata, translationMap);

  return fileParsedResult.rows.map((row: ImportedProductRow, index: number) =>
    buildImportRequest(row, index, productFieldMetadataMap, translationMap),
  );
}
